import { FormattedMessage } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex';
import { Button } from 'ui-components/components/button';

import { usePendingReturnContext } from '../../context/pending-return-context-provider';

import { messages } from './messages';
import style from './styles.module.less';

export function PendingReturnHeader() {
  const { cancelPendingEnhancedReturn } = usePendingReturnContext();

  return (
    <FlexRow className={style['pending-return-header']}>
      <Button onClick={() => cancelPendingEnhancedReturn(true)} theme='tertiary'>
        <FormattedMessage {...messages.cancelButtonLabel} />
      </Button>
    </FlexRow>
  );
}
